import { render, staticRenderFns } from "./OnboardingPage.vue?vue&type=template&id=5e0d86d0&scoped=true&"
import script from "./OnboardingPage.vue?vue&type=script&lang=js&"
export * from "./OnboardingPage.vue?vue&type=script&lang=js&"
import style0 from "./OnboardingPage.vue?vue&type=style&index=0&id=5e0d86d0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e0d86d0",
  null
  
)

export default component.exports